import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EmptyQuotesTable from './icon-empty-quotes-table.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EmptyQuotesTable {...validProps} />;
}
SvgComponent.iconName = 'emptyQuotesTable';

export const EmptyQuotesTableIcon = svgIconWrapper(SvgComponent);
